export default "__VITE_ASSET__DcDaNyOo__"